import { render, staticRenderFns } from "./CommissionDetail.vue?vue&type=template&id=b141553c&scoped=true&"
import script from "./CommissionDetail.vue?vue&type=script&lang=js&"
export * from "./CommissionDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommissionDetail.vue?vue&type=style&index=0&id=b141553c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b141553c",
  null
  
)

export default component.exports